import { Component, OnDestroy, OnInit } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit{
  title = 'BanCoppel';

  constructor( private titleService: Title, private metaService: Meta){

  }

  ngOnInit() {

    this.titleService.setTitle(this.title);
    this.metaService.addTags([
      {property: 'og:url', content: 'http://devbancoppel.maxvalue.com.mx/showPromo/9'},
      {property: 'og:type', content: 'website'},
      {property: 'og:title', content: 'Moshi Moshi Moshi Moshi'},
      {property: 'og:description', content: '2x1 en rollos, 20% OFF en bowls'},
      {property: 'og:image', content: 'http://devbancoppel.maxvalue.com.mx/bcp/MoshiMoshi.png'}
    ]);

  }

}
